export default "/_next/static/images/0efb5e7e1dc5d0b8d7220b57f3e461c7.jpg";